/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="create-return-page guest-return">
    <div class="layout-with-shoulder">
      <div class="shoulder-content">
        <div class="guest-return-wrapp">
          <div class="d-flex align-items-center justify-content-center">
            <svg class="o-icon mr-3 fill-black"><use xlink:href="#return-order"></use></svg>
            <h1 class="title title-small mb-0 cl-black">{{ $t('createGuestReturn') }}</h1>
          </div>
          <div class="subtitle">
            <p>{{ $t('createGuestReturnSubtitle') }}</p>
          </div>
          <form @submit="handleSubmit" class="account-content__body">
            <b-row no-gutters>
              <b-col sm="6">
                <b-form-group id="groupOrderNumber" label-for="order-number">
                  <base-input
                    name="order-number"
                    v-validate="'required'"
                    v-model="form.orderId"
                    type="text"
                    :autofocus="true"
                    :placeholder="$t('order-number') + '*'"
                    :validations="[
                      {
                        condition: errors.has('order-number'),
                        text: errors.first('order-number')
                      }
                    ]"
                  >
                  </base-input>
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group id="groupEmail" label-for="email">
                  <base-input
                    name="track-email"
                    v-validate="'required'"
                    v-model="form.email"
                    type="email"
                    :placeholder="$t('email') + '*'"
                    :validations="[
                      {
                        condition: errors.has('track-email'),
                        text: errors.first('track-email')
                      }
                    ]"
                  >
                  </base-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="form-errors is-invalid mb-3" v-show="serverValidation">
                  <p v-html="serverValidation"></p>
                </div>
                <button type="submit" class="btn btn-fullfill btn-fullfill-with-icon btn-fullfill-large btn-rounded">
                  <span class="text">{{ $t('send') }}</span>
                  <svg class="o-icon fill-white"><use xlink:href="#return-order"></use></svg>
                </button>
              </b-col>
            </b-row>
          </form>
          <div class="account-content__footer">
            <!-- <div class="wrapp-separator"></div>
            <div class="wrapp-footer-text">
              <span>{{ $t('go-to-return-refund-area') }}</span>
            </div>
            <div class="wrapp-footer-cta">
              <button class="btn btn-secondary btn-medium btn-secondary-with-icon btn-rounded">
                <span class="text">
                  {{ $t('return-refund-area') }}
                </span>
                <svg class="o-icon fill-black"><use xlink:href="#list-ul"></use></svg>
              </button>
            </div> -->
          </div>
          <!-- detail order -->
          <b-row v-if="detailOrder" class="mt-4_1 detail-order">
            <b-col md="10" class="mx-auto">
              <h1 class="title title-small text-uppercase text-center">{{ $t('order.my') }}</h1>
              <p class="subtitle text-center">
                {{$t('Order')}}: <strong>#{{detailOrder.entity_id}}</strong>
              </p>

              <div class="account-content__body container-fluid">
                <b-card-group deck>
                  <!-- card state order -->
                  <b-card class="text-center">
                    <b-card-text class="d-flex align-items-center justify-content-center">
                      <div>
                        {{$t('order.status')}}:<br>
                        <strong>{{$t(detailOrder.status)}}</strong>
                      </div>
                    </b-card-text>
                  </b-card>

                  <!-- card tracking -->
                  <!-- track information -->
                  <b-card class="text-center">
                    <b-card-text class="d-flex align-items-center justify-content-center">
                      <div>
                        {{$t('carrierName')}}: <strong>{{carrierName}}</strong><br/>
                        {{$t('trackingNumber')}}: <strong>{{trackingNumber}}</strong><br/>
                        <a :href="trackingLink">{{$t('followYourOrder')}}</a>
                      </div>
                    </b-card-text>
                  </b-card>
                </b-card-group>
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Rma from '@/services/Rma'
import BaseInput from 'theme/components/Form/BaseInput'

export default {
  inject: ['$validator'],
  data () {
    return {
      form: {
        orderId: '',
        email: ''
      },
      detailOrder: null,
      detailShipments: null,
      serverValidation: ''
    }
  },
  computed: {
    carrierName () {
      if (this.detailShipments) {
        return this.detailShipments.carrier_code
      }
      return ''
    },
    trackingNumber () {
      if (this.detailShipments) {
        return this.detailShipments.track_number
      }
      return ''
    },
    trackingLink () {
      if (this.detailShipments) {
        return this.detailShipments.title
      }
      return ''
    }
  },
  methods: {
    handleSubmit (evt) {
      const self = this
      evt && evt.preventDefault()
      self.serverValidation = false
      this.detailOrder = null
      this.detailShipments = null
      this.$validator.validate().then(isValid => {
        if (isValid) {
          self.$store.commit('ui/showLoader')
          Promise.all([
            Rma.checkGuestOrder({
              token: this.$store.state.user.token,
              storeViewCode: this.$store.state.ui.storeViewCode,
              orderId: this.form.orderId,
              email: this.form.email
            }).then((res) => {
              if (res.hasOwnProperty('errors')) {
                self.serverValidation = res.errors[0].message
              } else {
                self.$router.push({ name: 'newGuestReturn', params: { id: self.form.orderId, email: self.form.email } })
              }
            })
          ]).catch((err) => {
            let error = err.response
            if (error && error.data) {
              if (error.status === 404) {
                self.serverValidation = self.$t(`the order doesn't exists`)
              } else {
                self.serverValidation = self.$t(error.data)
              }
            } else {
              self.serverValidation = self.$t('GenericError')
            }
          })
            .finally(() => {
              self.$store.commit('ui/hideLoader')
            })
        }
      })
    },
    clearForm () {
      this.form.email = ''
      this.form.orderId = ''
    },

    getOrderInfo () {
      const _this = this
      return _this.$store.dispatch('orders/getOrderByIdAndEmail', {
        email: _this.form.email,
        orderId: _this.form.orderId
      }).then(order => {
        if (order) {
          _this.detailOrder = order
        } else {
          throw new Error('get order error')
        }
      })
    },
    getShipmentsInfo () {
      const _this = this
      return _this.$store.dispatch('orders/getShipmentsByOrderId', {
        orderId: _this.form.orderId
      }).then(res => {
        if (res && res.total_count > 0 && res.items[0].tracks.length) {
          _this.detailShipments = res.items[0].tracks[0]
        }
      })
    }
  },
  mounted () {
    this.clearForm()
  },
  components: {
    BaseInput
  }
}
</script>
<style lang="scss" scoped>
.detail-order{
  .card{
    border-radius: 0;
    .card-text{
      min-height: 300px;
    }
  }
}
</style>
